<svg xmlns="http://www.w3.org/2000/svg"
     width="64px" height="64px" stroke-linejoin="round"
     viewBox="0 0 64 64">
  <g fill="none" stroke="#000000" stroke-width="4">
  <path class="D20"
        d="M 5.00,17.00
           C 5.00,17.00 32.00,1.00 32.00,1.00
             32.00,1.00 59.00,17.00 59.00,17.00
             59.00,17.00 59.00,47.00 59.00,47.00
             59.00,47.00 32.00,63.00 32.00,63.00
             32.00,63.00 5.00,47.00 5.00,47.00
             5.00,47.00 5.00,17.00 5.00,17.00 Z
           M 32.00,14.00
           C 32.00,14.00 48.00,42.00 48.00,42.00
             48.00,42.00 16.00,42.00 16.00,42.00
             16.00,42.00 32.00,14.00 32.00,14.00 Z
           M 48.00,42.00
           C 48.00,42.00 32.00,63.00 32.00,63.00
             32.00,63.00 16.00,42.00 16.00,42.00
             16.00,42.00 5.00,17.00 5.00,17.00
             5.00,17.00 32.00,14.00 32.00,14.00
             32.00,14.00 59.00,17.00 59.00,17.00
             59.00,17.00 48.00,42.00 48.00,42.00 Z
           M 48.00,42.00
           C 48.00,42.00 59.00,47.00 59.00,47.00M 16.00,42.00
           C 16.00,42.00 5.00,47.00 5.00,47.00M 32.00,14.00
           C 32.00,14.00 32.00,1.00 32.00,1.00" />
   </g>
</svg>
